/* eslint-disable @typescript-eslint/no-explicit-any */

// DO NOT MANUALLY EDIT THIS FILE, this file is auto-generated.
// To add new icons place svg file in /assets/icons
// and run 'yarn add-icons'

import dynamic from 'next/dynamic';

interface IIconAttribute {
  component?: React.ComponentType;
  sprite?: TIconSprites;
  viewBox: string;
}

export enum IconSize {
  large = 'large',
  normal = 'normal',
  small = 'small',
}

type TIconSprites = 'amenities' | 'cards' | 'vehicleTypes';

export enum ICONS {
  ACCESSIBILITY = 'accessibility',
  ACCESSIBILITY_UNAVAILABLE = 'accessibility-unavailable',
  ACTIVITY = 'activity',
  AIR_CONDITIONER = 'air-conditioner',
  AIR_CONDITIONER_UNAVAILABLE = 'air-conditioner-unavailable',
  ALERT_CIRCLE = 'alert-circle',
  ALERT_OCTAGON = 'alert-octagon',
  AMEX = 'amex',
  APPLE_AUTH = 'apple-auth',
  ARCHIVE = 'archive',
  ARROW_RIGHT = 'arrow-right',
  AUDIO_INPUTS = 'audio-inputs',
  AUDIO_INPUTS_UNAVAILABLE = 'audio-inputs-unavailable',
  AWARD = 'award',
  AWNING = 'awning',
  AWNING_UNAVAILABLE = 'awning-unavailable',
  BACKUP_CAMERA = 'backup-camera',
  BACKUP_CAMERA_UNAVAILABLE = 'backup-camera-unavailable',
  BAR_CHART = 'bar-chart',
  BAR_CHART_2 = 'bar-chart-2',
  BED = 'bed',
  BELL = 'bell',
  BELL_OFF = 'bell-off',
  BIKE_RACK = 'bike-rack',
  BIKE_RACK_UNAVAILABLE = 'bike-rack-unavailable',
  BOLT = 'bolt',
  BOOK = 'book',
  BOOK_OPEN = 'book-open',
  BOOKER_DELIVERY_ONLY = 'booker-delivery-only',
  BOOKER_DRIVABLE = 'booker-drivable',
  BOOKER_TOWABLE = 'booker-towable',
  BOOKMARK = 'bookmark',
  BRIEFCASE = 'briefcase',
  CABIN_MAP = 'cabin-map',
  CALENDAR = 'calendar',
  CAMERA = 'camera',
  CAMERA_OFF = 'camera-off',
  CAMPER_VAN = 'camper-van',
  CAPTIONS_OFF = 'captions-off',
  CAPTIONS_ON = 'captions-on',
  CARET_LARGE = 'caret-large',
  CARET_SMALL = 'caret-small',
  CD_PLAYER = 'cd-player',
  CD_PLAYER_UNAVAILABLE = 'cd-player-unavailable',
  CEILING_FAN = 'ceiling-fan',
  CEILING_FAN_UNAVAILABLE = 'ceiling-fan-unavailable',
  CHECK = 'check',
  CHECK_CIRCLE = 'check-circle',
  CHECK_SQUARE = 'check-square',
  CHECKBOX_BACKGROUND = 'checkbox-background',
  CHECKMARK = 'checkmark',
  CHEVRON_LEFT_WHITE = 'chevron-left-white',
  CIRCLE = 'circle',
  CLASS_A = 'class-a',
  CLASS_B = 'class-b',
  CLASS_C = 'class-c',
  CLIPBOARD = 'clipboard',
  CLOCK = 'clock',
  CLOSE = 'close',
  COMPASS = 'compass',
  COPY = 'copy',
  COSTUMER_SERVICE = 'costumer-service',
  COUNTER = 'counter',
  CREDIT_CARD = 'credit-card',
  CURRENCY_CIRCLE_SIGN = 'currency-circle-sign',
  CURRENCY_SIGN = 'currency-sign',
  CURRENCY_SIGN_EU = 'currency-sign-eu',
  CURRENCY_SIGN_GBP = 'currency-sign-gbp',
  DASHBOARD = 'dashboard',
  DEFAULT_CARD = 'default-card',
  DELIVERY_VAN = 'delivery-van',
  DINERS = 'diners',
  DISCOVER = 'discover',
  DOWNLOAD = 'download',
  EDIT = 'edit',
  EDIT_DOCUMENT = 'edit-document',
  EDIT_INLINE = 'edit-inline',
  ENHANCED_CLEAN = 'enhanced-clean',
  EXTERNAL_LINK = 'external-link',
  EXTRA_STORAGE = 'extra-storage',
  EXTRA_STORAGE_UNAVAILABLE = 'extra-storage-unavailable',
  EYE = 'eye',
  EYE_OFF = 'eye-off',
  FACEBOOK = 'facebook',
  FACEBOOK_COLORED = 'facebook-colored',
  FACEBOOK_MARK = 'facebook-mark',
  FIFTH_WHEEL = 'fifth-wheel',
  FILE = 'file',
  FILE_TEXT = 'file-text',
  FILTER = 'filter',
  FLAG = 'flag',
  FOLDING_TRAILER = 'folding-trailer',
  FRESH_WATER = 'fresh-water',
  FRIDGE = 'fridge',
  FRIDGE_UNAVAILABLE = 'fridge-unavailable',
  FUEL = 'fuel',
  FUEL_TANK = 'fuel-tank',
  GENERATOR = 'generator',
  GENERATOR_UNAVAILABLE = 'generator-unavailable',
  GLOBE = 'globe',
  GOOGLE_COLORED = 'google-colored',
  GREEN_CHECK = 'green-check',
  BLUE_CHECK = 'blue-check',
  GRID = 'grid',
  GROSS_WEIGHT = 'gross-weight',
  HEADPHONES = 'headphones',
  HEART = 'heart',
  HEART_FILLED = 'heart-filled',
  HEATER = 'heater',
  HEATER_UNAVAILABLE = 'heater-unavailable',
  HELP = 'help',
  HOME = 'home',
  IMAGE = 'image',
  INBOX = 'inbox',
  INSTAGRAM_MARK = 'instagram-mark',
  INVERTER = 'inverter',
  INVERTER_UNAVAILABLE = 'inverter-unavailable',
  JCB = 'jcb',
  KITCHEN_SINK = 'kitchen-sink',
  KITCHEN_SINK_UNAVAILABLE = 'kitchen-sink-unavailable',
  LENGTH = 'length',
  LEVELING_JACK = 'leveling-jack',
  LEVELING_JACK_UNAVAILABLE = 'leveling-jack-unavailable',
  LINK = 'link',
  LIST = 'list',
  LOADING = 'loading',
  LOCK = 'lock',
  LOG_IN = 'log-in',
  LOG_OUT = 'log-out',
  MAIL = 'mail',
  MANAGE_VEHICLES = 'manage-vehicles',
  MAP = 'map',
  MAP_PIN = 'map-pin',
  MASTERCARD = 'mastercard',
  MAXIMIZE = 'maximize',
  MENU = 'menu',
  MESSAGE_CIRCLE = 'message-circle',
  MESSAGE_SQUARE = 'message-square',
  MICROWAVE = 'microwave',
  MICROWAVE_UNAVAILABLE = 'microwave-unavailable',
  MILEAGE = 'mileage',
  MINIMIZE = 'minimize',
  MINUS = 'minus',
  MINUS_CIRCLE = 'minus-circle',
  MINUS_CIRCLE_BIG = 'minus-circle-big',
  MINUS_SQUARE = 'minus-square',
  MONEY = 'money',
  MONITOR = 'monitor',
  MOON = 'moon',
  MORE_VERTICAL = 'more-vertical',
  MOVE = 'move',
  MUSIC = 'music',
  MUSIC_FESTIVAL = 'music-festival',
  MUSIC_FESTIVAL_NOT_ALLOWED = 'music-festival-not-allowed',
  NAVIGATION = 'navigation',
  OLD_TV = 'old-tv',
  OTHER = 'other',
  OUTDOORSY = 'outdoorsy',
  OVEN = 'oven',
  OVEN_UNAVAILABLE = 'oven-unavailable',
  PAUSE = 'pause',
  PEOPLE = 'people',
  PERCENT = 'percent',
  PET_FRIENDLY = 'pet-friendly',
  PET_NOT_ALLOWED = 'pet-not-allowed',
  PHONE = 'phone',
  PHONE_CALL = 'phone-call',
  PHONE_INCOMING = 'phone-incoming',
  PHONE_OFF = 'phone-off',
  PHONE_OUTGOING = 'phone-outgoing',
  PIE_CHART = 'pie-chart',
  PINTEREST = 'pinterest',
  PLAY = 'play',
  PLUS = 'plus',
  PLUS_CIRCLE = 'plus-circle',
  PLUS_CIRCLE_BIG = 'plus-circle-big',
  PLUS_SQUARE = 'plus-square',
  PRINTER = 'printer',
  PROPANE_TANK = 'propane-tank',
  RADIO = 'radio',
  RADIO_UNAVAILABLE = 'radio-unavailable',
  REFRESH_CCW = 'refresh-ccw',
  REFRESH_CW = 'refresh-cw',
  REPEAT = 'repeat',
  REPORT = 'report',
  ROTATE_CCW = 'rotate-ccw',
  ROTATE_CW = 'rotate-cw',
  SATELLITE = 'satellite',
  SATELLITE_UNAVAILABLE = 'satellite-unavailable',
  SAVE = 'save',
  SCISSORS = 'scissors',
  SEARCH = 'search',
  SEATBELTS = 'seatbelts',
  SETTINGS = 'settings',
  SEWAGE_TANK = 'sewage-tank',
  SHARE = 'share',
  SHIELD = 'shield',
  SHIELD_CHECK = 'shield-check',
  SHIELD_OFF = 'shield-off',
  SHIELD_PLUS = 'shield-plus',
  SHOPPING_BAG = 'shopping-bag',
  SHOPPING_CART = 'shopping-cart',
  SHOWER_INSIDE = 'shower-inside',
  SHOWER_INSIDE_UNAVAILABLE = 'shower-inside-unavailable',
  SHOWER_OUTSIDE = 'shower-outside',
  SHOWER_OUTSIDE_UNAVAILABLE = 'shower-outside-unavailable',
  SHUFFLE = 'shuffle',
  SLEEPS = 'sleeps',
  SLIDERS = 'sliders',
  SMARTPHONE = 'smartphone',
  SMOKING = 'smoking',
  SMOKING_NOT_ALLOWED = 'smoking-not-allowed',
  SOLAR = 'solar',
  SOLAR_UNAVAILABLE = 'solar-unavailable',
  STAR = 'star',
  STATIONARY = 'stationary',
  STAR_OUTLINE = 'star-outline',
  STOVE = 'stove',
  STOVE_UNAVAILABLE = 'stove-unavailable',
  SUN = 'sun',
  SUNRISE = 'sunrise',
  SUNSET = 'sunset',
  TABLE = 'table',
  TABLE_UNAVAILABLE = 'table-unavailable',
  TABLET = 'tablet',
  TAG = 'tag',
  TAILGATING = 'tailgating',
  TAILGATING_NOT_ALLOWED = 'tailgating-not-allowed',
  THUMBS_DOWN = 'thumbs-down',
  THUMBS_UP = 'thumbs-up',
  TOILET = 'toilet',
  TOILET_UNAVAILABLE = 'toilet-unavailable',
  TOW_HITCH = 'tow-hitch',
  TOW_HITCH_UNAVAILABLE = 'tow-hitch-unavailable',
  TOY_HAULER = 'toy-hauler',
  TRAILER = 'trailer',
  TRANSMISSION = 'transmission',
  TRENDING_DOWN = 'trending-down',
  TRENDING_UP = 'trending-up',
  TRIPS = 'trips',
  TRUCK = 'truck',
  TRUCK_CAMPER = 'truck-camper',
  TV = 'tv',
  TV_UNAVAILABLE = 'tv-unavailable',
  TWITTER = 'twitter',
  TWITTER_MARK = 'twitter-mark',
  UMBRELLA = 'umbrella',
  UNIONPAY = 'unionpay',
  UNLOCK = 'unlock',
  UPLOAD = 'upload',
  UPLOAD_CLOUD = 'upload-cloud',
  USER = 'user',
  USER_CHECK = 'user-check',
  USER_PLUS = 'user-plus',
  USERS = 'users',
  UTILITY_TRAILER = 'utility-trailer',
  VIDEO = 'video',
  VIDEO_OFF = 'video-off',
  VISA = 'visa',
  VOLUME = 'volume',
  WASHER_DRYER = 'washer-dryer',
  WASHER_DRYER_UNAVAILABLE = 'washer-dryer-unavailable',
  WATER_TANK = 'water-tank',
  WIFI = 'wifi',
  WIFI_OFF = 'wifi-off',
  WIFI_UNAVAILABLE = 'wifi-unavailable',
  X_CIRCLE = 'x-circle',
  X_SQUARE = 'x-square',
  YOUTUBE_MARK = 'youtube-mark',
  ZAP = 'zap',
  ZAP_OFF = 'zap-off',
  CARBON_MONOXIDE_DETECTOR_FOR_STAY = 'carbon-monoxide-detector-for-stay',
  SMOKE_DETECTOR_FOR_STAY = 'smoke-detector-for-stay',
  FIRE_EXTINGUISHER_FOR_STAY = 'fire-extinguisher-for-stay',
  FIRST_AID_KIT_FOR_STAY = 'first-aid-kit-for-stay',
  WHEELCHAIR_ACCESSIBLE_FOR_STAY = 'wheelchair-accessible-for-stay',
  ADA_ACCESSIBLE_FOR_STAY = 'ada-accessible-for-stay',
  WORKSPACE_FOR_STAY = 'workspace-for-stay',
  TV_DVD_FOR_STAY = 'tv-dvd-for-stay',
  WIFI_FOR_STAY = 'wifi-for-stay',
  FIRE_PIT_FOR_STAY = 'fire-pit-for-stay',
  BBQ_GRILL_FOR_STAY = 'bbq-grill-for-stay',
  POOL_FOR_STAY = 'pool-for-stay',
  HOT_TUB_FOR_STAY = 'hot-tub-for-stay',
  PICNIC_TABLE_FOR_STAY = 'picnic-table-for-stay',
  OUTDOOR_FURNITURE_FOR_STAY = 'outdoor-furniture-for-stay',
  PATIO_BALCONY_DECK_FOR_STAY = 'patio-balcony-deck-for-stay',
  INDOOR_SHOWER_FOR_STAY = 'indoor-shower-for-stay',
  OUTDOOR_SHOWER_FOR_STAY = 'outdoor-shower-for-stay',
  FLUSH_TOILET_FOR_STAY = 'flush-toilet-for-stay',
  COMPOST_TOILET_FOR_STAY = 'compost-toilet-for-stay',
  BATH_TOWELS_FOR_STAY = 'bath-towels-for-stay',
  TOILETRIES_FOR_STAY = 'toiletries-for-stay',
  HOT_WATER_FOR_STAY = 'hot-water-for-stay',
  TOILET_PAPER_FOR_STAY = 'toilet-paper-for-stay',
  REFRIGERATOR_FOR_STAY = 'refrigerator-for-stay',
  MICROWAVE_FOR_STAY = 'microwave-for-stay',
  OVEN_FOR_STAY = 'oven-for-stay',
  STOVE_FOR_STAY = 'stove-for-stay',
  KITCHEN_SINK_FOR_STAY = 'kitchen-sink-for-stay',
  DINING_TABLE_FOR_STAY = 'dining-table-for-stay',
  COFFEE_MAKER_FOR_STAY = 'coffee-maker-for-stay',
  COOKING_BASICS_FOR_STAY = 'cooking-basics-for-stay',
  DISHES_AND_UTENSILS_FOR_STAY = 'dishes-and-utensils-for-stay',
  POTS_AND_PANS_FOR_STAY = 'pots-and-pans-for-stay',
  POTABLE_WATER_FOR_STAY = 'potable-water-for-stay',
  AIR_CONDITIONING_FOR_STAY = 'air-conditioning-for-stay',
  INDOOR_FIREPLACE_FOR_STAY = 'indoor-fireplace-for-stay',
  CEILING_FAN_FOR_STAY = 'ceiling-fan-for-stay',
  PORTABLE_FAN_FOR_STAY = 'portable-fan-for-stay',
  HEATING_FOR_STAY = 'heating-for-stay',
  BLANKETS_FOR_STAY = 'blankets-for-stay',
  FRESH_LINENS_FOR_STAY = 'fresh-linens-for-stay',
  PILLOWS_FOR_STAY = 'pillows-for-stay',
  WASHER_FOR_STAY = 'washer-for-stay',
  DRYER_FOR_STAY = 'dryer-for-stay',
  CARBON_MONOXIDE_DETECTOR_FOR_STAY_UNAVAILABLE = 'carbon-monoxide-detector-for-stay-unavailable',
  SMOKE_DETECTOR_FOR_STAY_UNAVAILABLE = 'smoke-detector-for-stay-unavailable',
  FIRE_EXTINGUISHER_FOR_STAY_UNAVAILABLE = 'fire-extinguisher-for-stay-unavailable',
  FIRST_AID_KIT_FOR_STAY_UNAVAILABLE = 'first-aid-kit-for-stay-unavailable',
  WHEELCHAIR_ACCESSIBLE_FOR_STAY_UNAVAILABLE = 'wheelchair-accessible-for-stay-unavailable',
  ADA_ACCESSIBLE_FOR_STAY_UNAVAILABLE = 'ada-accessible-for-stay-unavailable',
  WORKSPACE_FOR_STAY_UNAVAILABLE = 'workspace-for-stay-unavailable',
  TV_DVD_FOR_STAY_UNAVAILABLE = 'tv-dvd-for-stay-unavailable',
  WIFI_FOR_STAY_UNAVAILABLE = 'wifi-for-stay-unavailable',
  FIRE_PIT_FOR_STAY_UNAVAILABLE = 'fire-pit-for-stay-unavailable',
  BBQ_GRILL_FOR_STAY_UNAVAILABLE = 'bbq-grill-for-stay-unavailable',
  POOL_FOR_STAY_UNAVAILABLE = 'pool-for-stay-unavailable',
  HOT_TUB_FOR_STAY_UNAVAILABLE = 'hot-tub-for-stay-unavailable',
  PICNIC_TABLE_FOR_STAY_UNAVAILABLE = 'picnic-table-for-stay-unavailable',
  OUTDOOR_FURNITURE_FOR_STAY_UNAVAILABLE = 'outdoor-furniture-for-stay-unavailable',
  PATIO_BALCONY_DECK_FOR_STAY_UNAVAILABLE = 'patio-balcony-deck-for-stay-unavailable',
  INDOOR_SHOWER_FOR_STAY_UNAVAILABLE = 'indoor-shower-for-stay-unavailable',
  OUTDOOR_SHOWER_FOR_STAY_UNAVAILABLE = 'outdoor-shower-for-stay-unavailable',
  FLUSH_TOILET_FOR_STAY_UNAVAILABLE = 'flush-toilet-for-stay-unavailable',
  COMPOST_TOILET_FOR_STAY_UNAVAILABLE = 'compost-toilet-for-stay-unavailable',
  BATH_TOWELS_FOR_STAY_UNAVAILABLE = 'bath-towels-for-stay-unavailable',
  TOILETRIES_FOR_STAY_UNAVAILABLE = 'toiletries-for-stay-unavailable',
  HOT_WATER_FOR_STAY_UNAVAILABLE = 'hot-water-for-stay-unavailable',
  TOILET_PAPER_FOR_STAY_UNAVAILABLE = 'toilet-paper-for-stay-unavailable',
  REFRIGERATOR_FOR_STAY_UNAVAILABLE = 'refrigerator-for-stay-unavailable',
  MICROWAVE_FOR_STAY_UNAVAILABLE = 'microwave-for-stay-unavailable',
  OVEN_FOR_STAY_UNAVAILABLE = 'oven-for-stay-unavailable',
  STOVE_FOR_STAY_UNAVAILABLE = 'stove-for-stay-unavailable',
  KITCHEN_SINK_FOR_STAY_UNAVAILABLE = 'kitchen-sink-for-stay-unavailable',
  DINING_TABLE_FOR_STAY_UNAVAILABLE = 'dining-table-for-stay-unavailable',
  COFFEE_MAKER_FOR_STAY_UNAVAILABLE = 'coffee-maker-for-stay-unavailable',
  COOKING_BASICS_FOR_STAY_UNAVAILABLE = 'cooking-basics-for-stay-unavailable',
  DISHES_AND_UTENSILS_FOR_STAY_UNAVAILABLE = 'dishes-and-utensils-for-stay-unavailable',
  POTS_AND_PANS_FOR_STAY_UNAVAILABLE = 'pots-and-pans-for-stay-unavailable',
  POTABLE_WATER_FOR_STAY_UNAVAILABLE = 'potable-water-for-stay-unavailable',
  AIR_CONDITIONING_FOR_STAY_UNAVAILABLE = 'air-conditioning-for-stay-unavailable',
  INDOOR_FIREPLACE_FOR_STAY_UNAVAILABLE = 'indoor-fireplace-for-stay-unavailable',
  CEILING_FAN_FOR_STAY_UNAVAILABLE = 'ceiling-fan-for-stay-unavailable',
  PORTABLE_FAN_FOR_STAY_UNAVAILABLE = 'portable-fan-for-stay-unavailable',
  HEATING_FOR_STAY_UNAVAILABLE = 'heating-for-stay-unavailable',
  BLANKETS_FOR_STAY_UNAVAILABLE = 'blankets-for-stay-unavailable',
  FRESH_LINENS_FOR_STAY_UNAVAILABLE = 'fresh-linens-for-stay-unavailable',
  PILLOWS_FOR_STAY_UNAVAILABLE = 'pillows-for-stay-unavailable',
  WASHER_FOR_STAY_UNAVAILABLE = 'washer-for-stay-unavailable',
  DRYER_FOR_STAY_UNAVAILABLE = 'dryer-for-stay-unavailable',
  ADDRESS_MARKER = 'address-marker',
}

export const ICON_PROPERTIES: Record<ICONS, IIconAttribute> = {
  [ICONS.BATH_TOWELS_FOR_STAY]: {
    component: dynamic(() => import('@/assets/icons/amenities/bath-towels.svg') as any, {
      ssr: false,
    }),
    viewBox: '0 0 24 24',
  },
  [ICONS.WASHER_FOR_STAY]: {
    component: dynamic(() => import('@/assets/icons/amenities/washer-dryer.svg') as any, {
      ssr: false,
    }),
    viewBox: '0 0 24 24',
  },
  [ICONS.DRYER_FOR_STAY]: {
    component: dynamic(() => import('@/assets/icons/amenities/washer-dryer.svg') as any, {
      ssr: false,
    }),
    viewBox: '0 0 24 24',
  },
  [ICONS.HEATING_FOR_STAY]: {
    component: dynamic(() => import('@/assets/icons/amenities/heater.svg') as any, {
      ssr: false,
    }),
    viewBox: '0 0 24 24',
  },
  [ICONS.PORTABLE_FAN_FOR_STAY]: {
    component: dynamic(() => import('@/assets/icons/amenities/ceiling-fan.svg') as any, {
      ssr: false,
    }),
    viewBox: '0 0 24 24',
  },
  [ICONS.CEILING_FAN_FOR_STAY]: {
    component: dynamic(() => import('@/assets/icons/amenities/ceiling-fan.svg') as any, {
      ssr: false,
    }),
    viewBox: '0 0 24 24',
  },
  [ICONS.AIR_CONDITIONING_FOR_STAY]: {
    component: dynamic(() => import('@/assets/icons/amenities/air-conditioner.svg') as any, {
      ssr: false,
    }),
    viewBox: '0 0 24 24',
  },
  [ICONS.DINING_TABLE_FOR_STAY]: {
    component: dynamic(() => import('@/assets/icons/amenities/table.svg') as any, {
      ssr: false,
    }),
    viewBox: '0 0 24 24',
  },
  [ICONS.KITCHEN_SINK_FOR_STAY]: {
    component: dynamic(() => import('@/assets/icons/amenities/kitchen-sink.svg') as any, {
      ssr: false,
    }),
    viewBox: '0 0 24 24',
  },
  [ICONS.STOVE_FOR_STAY]: {
    component: dynamic(() => import('@/assets/icons/amenities/stove.svg') as any, {
      ssr: false,
    }),
    viewBox: '0 0 24 24',
  },
  [ICONS.OVEN_FOR_STAY]: {
    component: dynamic(() => import('@/assets/icons/amenities/oven.svg') as any, {
      ssr: false,
    }),
    viewBox: '0 0 24 24',
  },
  [ICONS.MICROWAVE_FOR_STAY]: {
    component: dynamic(() => import('@/assets/icons/amenities/microwave.svg') as any, {
      ssr: false,
    }),
    viewBox: '0 0 24 24',
  },
  [ICONS.REFRIGERATOR_FOR_STAY]: {
    component: dynamic(() => import('@/assets/icons/amenities/fridge.svg') as any, {
      ssr: false,
    }),
    viewBox: '0 0 24 24',
  },
  [ICONS.HOT_WATER_FOR_STAY]: {
    component: dynamic(() => import('@/assets/icons/amenities/fresh-water.svg') as any, {
      ssr: false,
    }),
    viewBox: '0 0 24 24',
  },
  [ICONS.COMPOST_TOILET_FOR_STAY]: {
    component: dynamic(() => import('@/assets/icons/amenities/compost.svg') as any, {
      ssr: false,
    }),
    viewBox: '0 0 24 24',
  },
  [ICONS.FLUSH_TOILET_FOR_STAY]: {
    component: dynamic(() => import('@/assets/icons/amenities/toilet.svg') as any, {
      ssr: false,
    }),
    viewBox: '0 0 24 24',
  },
  [ICONS.OUTDOOR_SHOWER_FOR_STAY]: {
    component: dynamic(() => import('@/assets/icons/amenities/shower-outside.svg') as any, {
      ssr: false,
    }),
    viewBox: '0 0 24 24',
  },
  [ICONS.INDOOR_SHOWER_FOR_STAY]: {
    component: dynamic(() => import('@/assets/icons/amenities/shower-inside.svg') as any, {
      ssr: false,
    }),
    viewBox: '0 0 24 24',
  },
  [ICONS.PICNIC_TABLE_FOR_STAY]: {
    component: dynamic(() => import('@/assets/icons/amenities/table.svg') as any, {
      ssr: false,
    }),
    viewBox: '0 0 24 24',
  },
  [ICONS.WIFI_FOR_STAY]: {
    component: dynamic(() => import('@/assets/icons/amenities/wifi.svg') as any, {
      ssr: false,
    }),
    viewBox: '0 0 24 24',
  },
  [ICONS.TV_DVD_FOR_STAY]: {
    component: dynamic(() => import('@/assets/icons/amenities/tv.svg') as any, {
      ssr: false,
    }),
    viewBox: '0 0 24 24',
  },
  [ICONS.WORKSPACE_FOR_STAY]: {
    component: dynamic(() => import('@/assets/icons/amenities/workspace.svg') as any, {
      ssr: false,
    }),
    viewBox: '0 0 24 24',
  },
  [ICONS.ADA_ACCESSIBLE_FOR_STAY]: {
    component: dynamic(() => import('@/assets/icons/amenities/wheelchair.svg') as any, {
      ssr: false,
    }),
    viewBox: '0 0 24 24',
  },
  [ICONS.WHEELCHAIR_ACCESSIBLE_FOR_STAY]: {
    component: dynamic(() => import('@/assets/icons/amenities/wheelchair.svg') as any, {
      ssr: false,
    }),
    viewBox: '0 0 24 24',
  },
  [ICONS.TOILETRIES_FOR_STAY]: {
    component: dynamic(() => import('@/assets/icons/amenities/toiletries.svg') as any, {
      ssr: false,
    }),
    viewBox: '0 0 24 24',
  },
  [ICONS.POTABLE_WATER_FOR_STAY]: {
    component: dynamic(() => import('@/assets/icons/amenities/fresh-water.svg') as any, {
      ssr: false,
    }),
    viewBox: '0 0 24 24',
  },
  [ICONS.TOILET_PAPER_FOR_STAY]: {
    component: dynamic(() => import('@/assets/icons/amenities/toilet-paper.svg') as any, {
      ssr: false,
    }),
    viewBox: '0 0 24 24',
  },
  [ICONS.PILLOWS_FOR_STAY]: {
    component: dynamic(() => import('@/assets/icons/amenities/pillows.svg') as any, {
      ssr: false,
    }),
    viewBox: '0 0 24 24',
  },
  [ICONS.BLANKETS_FOR_STAY]: {
    component: dynamic(() => import('@/assets/icons/amenities/blankets.svg') as any, {
      ssr: false,
    }),
    viewBox: '0 0 24 24',
  },
  [ICONS.DISHES_AND_UTENSILS_FOR_STAY]: {
    component: dynamic(() => import('@/assets/icons/amenities/dishes-and-utensils.svg') as any, {
      ssr: false,
    }),
    viewBox: '0 0 24 24',
  },
  [ICONS.COFFEE_MAKER_FOR_STAY]: {
    component: dynamic(() => import('@/assets/icons/amenities/coffee-maker.svg') as any, {
      ssr: false,
    }),
    viewBox: '0 0 24 24',
  },
  [ICONS.SMOKE_DETECTOR_FOR_STAY]: {
    component: dynamic(() => import('@/assets/icons/amenities/smoke-detector.svg') as any, {
      ssr: false,
    }),
    viewBox: '0 0 24 24',
  },
  [ICONS.FRESH_LINENS_FOR_STAY]: {
    component: dynamic(() => import('@/assets/icons/amenities/linens.svg') as any, {
      ssr: false,
    }),
    viewBox: '0 0 24 24',
  },
  [ICONS.COOKING_BASICS_FOR_STAY]: {
    component: dynamic(() => import('@/assets/icons/amenities/cooking-basics.svg') as any, {
      ssr: false,
    }),
    viewBox: '0 0 24 24',
  },
  [ICONS.POTS_AND_PANS_FOR_STAY]: {
    component: dynamic(() => import('@/assets/icons/amenities/pots-and-pans.svg') as any, {
      ssr: false,
    }),
    viewBox: '0 0 24 24',
  },
  [ICONS.OUTDOOR_FURNITURE_FOR_STAY]: {
    component: dynamic(() => import('@/assets/icons/amenities/outdoor-furniture.svg') as any, {
      ssr: false,
    }),
    viewBox: '0 0 24 24',
  },
  [ICONS.PATIO_BALCONY_DECK_FOR_STAY]: {
    component: dynamic(() => import('@/assets/icons/amenities/patio.svg') as any, {
      ssr: false,
    }),
    viewBox: '0 0 24 24',
  },
  [ICONS.POOL_FOR_STAY]: {
    component: dynamic(() => import('@/assets/icons/amenities/pool.svg') as any, {
      ssr: false,
    }),
    viewBox: '0 0 24 24',
  },
  [ICONS.BBQ_GRILL_FOR_STAY]: {
    component: dynamic(() => import('@/assets/icons/amenities/grill.svg') as any, {
      ssr: false,
    }),
    viewBox: '0 0 24 24',
  },
  [ICONS.FIRE_PIT_FOR_STAY]: {
    component: dynamic(() => import('@/assets/icons/amenities/firepit.svg') as any, {
      ssr: false,
    }),
    viewBox: '0 0 24 24',
  },
  [ICONS.HOT_TUB_FOR_STAY]: {
    component: dynamic(() => import('@/assets/icons/amenities/hot-tub.svg') as any, {
      ssr: false,
    }),
    viewBox: '0 0 24 24',
  },

  [ICONS.FIRST_AID_KIT_FOR_STAY]: {
    component: dynamic(() => import('@/assets/icons/amenities/first-aid-kit.svg') as any, {
      ssr: false,
    }),
    viewBox: '0 0 24 24',
  },
  [ICONS.CARBON_MONOXIDE_DETECTOR_FOR_STAY]: {
    component: dynamic(() => import('@/assets/icons/amenities/co2-detector.svg') as any, {
      ssr: false,
    }),
    viewBox: '0 0 24 24',
  },
  [ICONS.FIRE_EXTINGUISHER_FOR_STAY]: {
    component: dynamic(() => import('@/assets/icons/amenities/fire-extinguisher.svg') as any, {
      ssr: false,
    }),
    viewBox: '0 0 24 24',
  },
  [ICONS.INDOOR_FIREPLACE_FOR_STAY]: {
    component: dynamic(() => import('@/assets/icons/amenities/fireplace.svg') as any, {
      ssr: false,
    }),
    viewBox: '0 0 24 24',
  },
  [ICONS.BATH_TOWELS_FOR_STAY_UNAVAILABLE]: {
    component: dynamic(
      () => import('@/assets/icons/amenities/bath-towels-unavailable.svg') as any,
      {
        ssr: false,
      },
    ),
    viewBox: '0 0 24 24',
  },
  [ICONS.WASHER_FOR_STAY_UNAVAILABLE]: {
    component: dynamic(
      () => import('@/assets/icons/amenities/washer-dryer-unavailable.svg') as any,
      {
        ssr: false,
      },
    ),
    viewBox: '0 0 24 24',
  },
  [ICONS.DRYER_FOR_STAY_UNAVAILABLE]: {
    component: dynamic(
      () => import('@/assets/icons/amenities/washer-dryer-unavailable.svg') as any,
      {
        ssr: false,
      },
    ),
    viewBox: '0 0 24 24',
  },
  [ICONS.HEATING_FOR_STAY_UNAVAILABLE]: {
    component: dynamic(() => import('@/assets/icons/amenities/heater-unavailable.svg') as any, {
      ssr: false,
    }),
    viewBox: '0 0 24 24',
  },
  [ICONS.PORTABLE_FAN_FOR_STAY_UNAVAILABLE]: {
    component: dynamic(
      () => import('@/assets/icons/amenities/ceiling-fan-unavailable.svg') as any,
      {
        ssr: false,
      },
    ),
    viewBox: '0 0 24 24',
  },
  [ICONS.CEILING_FAN_FOR_STAY_UNAVAILABLE]: {
    component: dynamic(
      () => import('@/assets/icons/amenities/ceiling-fan-unavailable.svg') as any,
      {
        ssr: false,
      },
    ),
    viewBox: '0 0 24 24',
  },
  [ICONS.AIR_CONDITIONING_FOR_STAY_UNAVAILABLE]: {
    component: dynamic(
      () => import('@/assets/icons/amenities/air-conditioner-unavailable.svg') as any,
      {
        ssr: false,
      },
    ),
    viewBox: '0 0 24 24',
  },
  [ICONS.DINING_TABLE_FOR_STAY_UNAVAILABLE]: {
    component: dynamic(() => import('@/assets/icons/amenities/table-unavailable.svg') as any, {
      ssr: false,
    }),
    viewBox: '0 0 24 24',
  },
  [ICONS.KITCHEN_SINK_FOR_STAY_UNAVAILABLE]: {
    component: dynamic(
      () => import('@/assets/icons/amenities/kitchen-sink-unavailable.svg') as any,
      {
        ssr: false,
      },
    ),
    viewBox: '0 0 24 24',
  },
  [ICONS.STOVE_FOR_STAY_UNAVAILABLE]: {
    component: dynamic(() => import('@/assets/icons/amenities/stove-unavailable.svg') as any, {
      ssr: false,
    }),
    viewBox: '0 0 24 24',
  },
  [ICONS.OVEN_FOR_STAY_UNAVAILABLE]: {
    component: dynamic(() => import('@/assets/icons/amenities/oven-unavailable.svg') as any, {
      ssr: false,
    }),
    viewBox: '0 0 24 24',
  },
  [ICONS.MICROWAVE_FOR_STAY_UNAVAILABLE]: {
    component: dynamic(() => import('@/assets/icons/amenities/microwave-unavailable.svg') as any, {
      ssr: false,
    }),
    viewBox: '0 0 24 24',
  },
  [ICONS.REFRIGERATOR_FOR_STAY_UNAVAILABLE]: {
    component: dynamic(() => import('@/assets/icons/amenities/fridge-unavailable.svg') as any, {
      ssr: false,
    }),
    viewBox: '0 0 24 24',
  },
  [ICONS.HOT_WATER_FOR_STAY_UNAVAILABLE]: {
    component: dynamic(
      () => import('@/assets/icons/amenities/fresh-water-unavailable.svg') as any,
      {
        ssr: false,
      },
    ),
    viewBox: '0 0 24 24',
  },
  [ICONS.COMPOST_TOILET_FOR_STAY_UNAVAILABLE]: {
    component: dynamic(() => import('@/assets/icons/amenities/compost-unavailable.svg') as any, {
      ssr: false,
    }),
    viewBox: '0 0 24 24',
  },
  [ICONS.FLUSH_TOILET_FOR_STAY_UNAVAILABLE]: {
    component: dynamic(() => import('@/assets/icons/amenities/toilet-unavailable.svg') as any, {
      ssr: false,
    }),
    viewBox: '0 0 24 24',
  },
  [ICONS.OUTDOOR_SHOWER_FOR_STAY_UNAVAILABLE]: {
    component: dynamic(
      () => import('@/assets/icons/amenities/shower-outside-unavailable.svg') as any,
      {
        ssr: false,
      },
    ),
    viewBox: '0 0 24 24',
  },
  [ICONS.INDOOR_SHOWER_FOR_STAY_UNAVAILABLE]: {
    component: dynamic(
      () => import('@/assets/icons/amenities/shower-inside-unavailable.svg') as any,
      {
        ssr: false,
      },
    ),
    viewBox: '0 0 24 24',
  },
  [ICONS.PICNIC_TABLE_FOR_STAY_UNAVAILABLE]: {
    component: dynamic(() => import('@/assets/icons/amenities/table-unavailable.svg') as any, {
      ssr: false,
    }),
    viewBox: '0 0 24 24',
  },
  [ICONS.WIFI_FOR_STAY_UNAVAILABLE]: {
    component: dynamic(() => import('@/assets/icons/amenities/wifi-unavailable.svg') as any, {
      ssr: false,
    }),
    viewBox: '0 0 24 24',
  },
  [ICONS.TV_DVD_FOR_STAY_UNAVAILABLE]: {
    component: dynamic(() => import('@/assets/icons/amenities/tv-unavailable.svg') as any, {
      ssr: false,
    }),
    viewBox: '0 0 24 24',
  },
  [ICONS.WORKSPACE_FOR_STAY_UNAVAILABLE]: {
    component: dynamic(() => import('@/assets/icons/amenities/workspace-unavailable.svg') as any, {
      ssr: false,
    }),
    viewBox: '0 0 24 24',
  },
  [ICONS.ADA_ACCESSIBLE_FOR_STAY_UNAVAILABLE]: {
    component: dynamic(() => import('@/assets/icons/amenities/wheelchair-unavailable.svg') as any, {
      ssr: false,
    }),
    viewBox: '0 0 24 24',
  },
  [ICONS.WHEELCHAIR_ACCESSIBLE_FOR_STAY_UNAVAILABLE]: {
    component: dynamic(() => import('@/assets/icons/amenities/wheelchair-unavailable.svg') as any, {
      ssr: false,
    }),
    viewBox: '0 0 24 24',
  },
  [ICONS.TOILETRIES_FOR_STAY_UNAVAILABLE]: {
    component: dynamic(() => import('@/assets/icons/amenities/toiletries-unavailable.svg') as any, {
      ssr: false,
    }),
    viewBox: '0 0 24 24',
  },
  [ICONS.POTABLE_WATER_FOR_STAY_UNAVAILABLE]: {
    component: dynamic(
      () => import('@/assets/icons/amenities/fresh-water-unavailable.svg') as any,
      {
        ssr: false,
      },
    ),
    viewBox: '0 0 24 24',
  },
  [ICONS.TOILET_PAPER_FOR_STAY_UNAVAILABLE]: {
    component: dynamic(
      () => import('@/assets/icons/amenities/toilet-paper-unavailable.svg') as any,
      {
        ssr: false,
      },
    ),
    viewBox: '0 0 24 24',
  },
  [ICONS.PILLOWS_FOR_STAY_UNAVAILABLE]: {
    component: dynamic(() => import('@/assets/icons/amenities/pillows-unavailable.svg') as any, {
      ssr: false,
    }),
    viewBox: '0 0 24 24',
  },
  [ICONS.BLANKETS_FOR_STAY_UNAVAILABLE]: {
    component: dynamic(() => import('@/assets/icons/amenities/blankets-unavailable.svg') as any, {
      ssr: false,
    }),
    viewBox: '0 0 24 24',
  },
  [ICONS.DISHES_AND_UTENSILS_FOR_STAY_UNAVAILABLE]: {
    component: dynamic(
      () => import('@/assets/icons/amenities/dishes-and-utensils-unavailable.svg') as any,
      {
        ssr: false,
      },
    ),
    viewBox: '0 0 24 24',
  },
  [ICONS.COFFEE_MAKER_FOR_STAY_UNAVAILABLE]: {
    component: dynamic(
      () => import('@/assets/icons/amenities/coffee-maker-unavailable.svg') as any,
      {
        ssr: false,
      },
    ),
    viewBox: '0 0 24 24',
  },
  [ICONS.SMOKE_DETECTOR_FOR_STAY_UNAVAILABLE]: {
    component: dynamic(
      () => import('@/assets/icons/amenities/smoke-detector-unavailable.svg') as any,
      {
        ssr: false,
      },
    ),
    viewBox: '0 0 24 24',
  },
  [ICONS.FRESH_LINENS_FOR_STAY_UNAVAILABLE]: {
    component: dynamic(() => import('@/assets/icons/amenities/linens-unavailable.svg') as any, {
      ssr: false,
    }),
    viewBox: '0 0 24 24',
  },
  [ICONS.COOKING_BASICS_FOR_STAY_UNAVAILABLE]: {
    component: dynamic(
      () => import('@/assets/icons/amenities/cooking-basics-unavailable.svg') as any,
      {
        ssr: false,
      },
    ),
    viewBox: '0 0 24 24',
  },
  [ICONS.POTS_AND_PANS_FOR_STAY_UNAVAILABLE]: {
    component: dynamic(
      () => import('@/assets/icons/amenities/pots-and-pans-unavailable.svg') as any,
      {
        ssr: false,
      },
    ),
    viewBox: '0 0 24 24',
  },
  [ICONS.OUTDOOR_FURNITURE_FOR_STAY_UNAVAILABLE]: {
    component: dynamic(
      () => import('@/assets/icons/amenities/outdoor-furniture-unavailable.svg') as any,
      {
        ssr: false,
      },
    ),
    viewBox: '0 0 24 24',
  },
  [ICONS.PATIO_BALCONY_DECK_FOR_STAY_UNAVAILABLE]: {
    component: dynamic(() => import('@/assets/icons/amenities/patio-unavailable.svg') as any, {
      ssr: false,
    }),
    viewBox: '0 0 24 24',
  },
  [ICONS.POOL_FOR_STAY_UNAVAILABLE]: {
    component: dynamic(() => import('@/assets/icons/amenities/pool-unavailable.svg') as any, {
      ssr: false,
    }),
    viewBox: '0 0 24 24',
  },
  [ICONS.BBQ_GRILL_FOR_STAY_UNAVAILABLE]: {
    component: dynamic(() => import('@/assets/icons/amenities/grill-unavailable.svg') as any, {
      ssr: false,
    }),
    viewBox: '0 0 24 24',
  },
  [ICONS.FIRE_PIT_FOR_STAY_UNAVAILABLE]: {
    component: dynamic(() => import('@/assets/icons/amenities/firepit-unavailable.svg') as any, {
      ssr: false,
    }),
    viewBox: '0 0 24 24',
  },
  [ICONS.HOT_TUB_FOR_STAY_UNAVAILABLE]: {
    component: dynamic(() => import('@/assets/icons/amenities/hot-tub-unavailable.svg') as any, {
      ssr: false,
    }),
    viewBox: '0 0 24 24',
  },

  [ICONS.FIRST_AID_KIT_FOR_STAY_UNAVAILABLE]: {
    component: dynamic(
      () => import('@/assets/icons/amenities/first-aid-kit-unavailable.svg') as any,
      {
        ssr: false,
      },
    ),
    viewBox: '0 0 24 24',
  },
  [ICONS.CARBON_MONOXIDE_DETECTOR_FOR_STAY_UNAVAILABLE]: {
    component: dynamic(
      () => import('@/assets/icons/amenities/co2-detector-unavailable.svg') as any,
      {
        ssr: false,
      },
    ),
    viewBox: '0 0 24 24',
  },
  [ICONS.FIRE_EXTINGUISHER_FOR_STAY_UNAVAILABLE]: {
    component: dynamic(
      () => import('@/assets/icons/amenities/fire-extinguisher-unavailable.svg') as any,
      {
        ssr: false,
      },
    ),
    viewBox: '0 0 24 24',
  },
  [ICONS.INDOOR_FIREPLACE_FOR_STAY_UNAVAILABLE]: {
    component: dynamic(() => import('@/assets/icons/amenities/fireplace-unavailable.svg') as any, {
      ssr: false,
    }),
    viewBox: '0 0 24 24',
  },
  [ICONS.ACCESSIBILITY]: {
    component: dynamic(() => import('@/assets/icons/accessibility.svg') as any, { ssr: false }),
    viewBox: '0 0 24 24',
  },
  [ICONS.ACCESSIBILITY_UNAVAILABLE]: {
    component: dynamic(() => import('@/assets/icons/accessibility-unavailable.svg') as any, {
      ssr: false,
    }),
    viewBox: '0 0 24 24',
  },
  [ICONS.ACTIVITY]: {
    component: dynamic(() => import('@/assets/icons/activity.svg') as any, { ssr: false }),
    viewBox: '0 0 24 24',
  },
  [ICONS.AIR_CONDITIONER]: { sprite: 'amenities', viewBox: '0 0 24 24' },
  [ICONS.AIR_CONDITIONER_UNAVAILABLE]: { sprite: 'amenities', viewBox: '0 0 24 24' },
  [ICONS.ALERT_CIRCLE]: {
    component: dynamic(() => import('@/assets/icons/alert-circle.svg') as any, { ssr: false }),
    viewBox: '0 0 24 24',
  },
  [ICONS.ALERT_OCTAGON]: {
    component: dynamic(() => import('@/assets/icons/alert-octagon.svg') as any, { ssr: false }),
    viewBox: '0 0 24 24',
  },
  [ICONS.AMEX]: { sprite: 'cards', viewBox: '0 0 24 24' },
  [ICONS.APPLE_AUTH]: {
    component: dynamic(() => import('@/assets/icons/apple-auth.svg') as any, { ssr: false }),
    viewBox: '0 0 24 24',
  },
  [ICONS.ARCHIVE]: {
    component: dynamic(() => import('@/assets/icons/archive.svg') as any, { ssr: false }),
    viewBox: '0 0 24 24',
  },
  [ICONS.ARROW_RIGHT]: {
    component: dynamic(() => import('@/assets/icons/arrow-right.svg') as any, { ssr: false }),
    viewBox: '0 0 20 20',
  },
  [ICONS.AUDIO_INPUTS]: { sprite: 'amenities', viewBox: '0 0 24 24' },
  [ICONS.AUDIO_INPUTS_UNAVAILABLE]: { sprite: 'amenities', viewBox: '0 0 24 24' },
  [ICONS.AWARD]: {
    component: dynamic(() => import('@/assets/icons/award.svg') as any, { ssr: false }),
    viewBox: '0 0 24 24',
  },
  [ICONS.AWNING]: { sprite: 'amenities', viewBox: '0 0 24 24' },
  [ICONS.AWNING_UNAVAILABLE]: { sprite: 'amenities', viewBox: '0 0 24 24' },
  [ICONS.BACKUP_CAMERA]: { sprite: 'amenities', viewBox: '0 0 24 24' },
  [ICONS.BACKUP_CAMERA_UNAVAILABLE]: { sprite: 'amenities', viewBox: '0 0 24 24' },
  [ICONS.BAR_CHART]: {
    component: dynamic(() => import('@/assets/icons/bar-chart.svg') as any, { ssr: false }),
    viewBox: '0 0 24 24',
  },
  [ICONS.BAR_CHART_2]: {
    component: dynamic(() => import('@/assets/icons/bar-chart-2.svg') as any, { ssr: false }),
    viewBox: '0 0 24 24',
  },
  [ICONS.BED]: {
    component: dynamic(() => import('@/assets/icons/bed.svg') as any, { ssr: false }),
    viewBox: '0 0 20 18',
  },
  [ICONS.BELL]: {
    component: dynamic(() => import('@/assets/icons/bell.svg') as any, { ssr: false }),
    viewBox: '0 0 24 24',
  },
  [ICONS.BELL_OFF]: {
    component: dynamic(() => import('@/assets/icons/bell-off.svg') as any, { ssr: false }),
    viewBox: '0 0 24 24',
  },
  [ICONS.BIKE_RACK]: { sprite: 'amenities', viewBox: '0 0 24 24' },
  [ICONS.BIKE_RACK_UNAVAILABLE]: { sprite: 'amenities', viewBox: '0 0 24 24' },
  [ICONS.BOLT]: {
    component: dynamic(() => import('@/assets/icons/bolt.svg') as any, { ssr: false }),
    viewBox: '0 0 24 24',
  },
  [ICONS.BOOK]: {
    component: dynamic(() => import('@/assets/icons/book.svg') as any, { ssr: false }),
    viewBox: '0 0 24 24',
  },
  [ICONS.BOOK_OPEN]: {
    component: dynamic(() => import('@/assets/icons/book-open.svg') as any, { ssr: false }),
    viewBox: '0 0 24 24',
  },
  [ICONS.BOOKER_DELIVERY_ONLY]: {
    component: dynamic(() => import('@/assets/icons/booker-delivery-only.svg') as any, {
      ssr: false,
    }),
    viewBox: '0 0 24 24',
  },
  [ICONS.BOOKER_DRIVABLE]: {
    component: dynamic(() => import('@/assets/icons/booker-drivable.svg') as any, { ssr: false }),
    viewBox: '0 0 24 24',
  },
  [ICONS.BOOKER_TOWABLE]: {
    component: dynamic(() => import('@/assets/icons/booker-towable.svg') as any, { ssr: false }),
    viewBox: '0 0 24 24',
  },
  [ICONS.BOOKMARK]: {
    component: dynamic(() => import('@/assets/icons/bookmark.svg') as any, { ssr: false }),
    viewBox: '0 0 24 24',
  },
  [ICONS.BRIEFCASE]: {
    component: dynamic(() => import('@/assets/icons/briefcase.svg') as any, { ssr: false }),
    viewBox: '0 0 24 24',
  },
  [ICONS.CABIN_MAP]: {
    component: dynamic(() => import('@/assets/icons/cabin-map.svg') as any, { ssr: false }),
    viewBox: '0 0 24 24',
  },
  [ICONS.CALENDAR]: {
    component: dynamic(() => import('@/assets/icons/calendar.svg') as any, { ssr: false }),
    viewBox: '0 0 24 24',
  },
  [ICONS.CAMERA]: {
    component: dynamic(() => import('@/assets/icons/camera.svg') as any, { ssr: false }),
    viewBox: '0 0 24 24',
  },
  [ICONS.CAMERA_OFF]: {
    component: dynamic(() => import('@/assets/icons/camera-off.svg') as any, { ssr: false }),
    viewBox: '0 0 24 24',
  },
  [ICONS.CAMPER_VAN]: { sprite: 'vehicleTypes', viewBox: '0 0 36 36' },
  [ICONS.CAPTIONS_OFF]: {
    component: dynamic(() => import('@/assets/icons/captions-off.svg') as any, { ssr: false }),
    viewBox: '0 0 24 20',
  },
  [ICONS.CAPTIONS_ON]: {
    component: dynamic(() => import('@/assets/icons/captions-on.svg') as any, { ssr: false }),
    viewBox: '0 0 24 26',
  },
  [ICONS.CARET_LARGE]: {
    component: dynamic(() => import('@/assets/icons/caret-large.svg') as any, { ssr: false }),
    viewBox: '0 0 20 20',
  },
  [ICONS.CARET_SMALL]: {
    component: dynamic(() => import('@/assets/icons/caret-small.svg') as any, { ssr: false }),
    viewBox: '0 0 20 20',
  },
  [ICONS.CD_PLAYER]: { sprite: 'amenities', viewBox: '0 0 24 24' },
  [ICONS.CD_PLAYER_UNAVAILABLE]: { sprite: 'amenities', viewBox: '0 0 24 24' },
  [ICONS.CEILING_FAN]: { sprite: 'amenities', viewBox: '0 0 24 24' },
  [ICONS.CEILING_FAN_UNAVAILABLE]: { sprite: 'amenities', viewBox: '0 0 24 24' },
  [ICONS.CHECK]: {
    component: dynamic(() => import('@/assets/icons/check.svg') as any, { ssr: false }),
    viewBox: '0 0 24 24',
  },
  [ICONS.CHECK_CIRCLE]: {
    component: dynamic(() => import('@/assets/icons/check-circle.svg') as any, { ssr: false }),
    viewBox: '0 0 24 24',
  },
  [ICONS.CHECK_SQUARE]: {
    component: dynamic(() => import('@/assets/icons/check-square.svg') as any, { ssr: false }),
    viewBox: '0 0 24 24',
  },
  [ICONS.CHECKBOX_BACKGROUND]: {
    component: dynamic(() => import('@/assets/icons/checkbox-background.svg') as any, {
      ssr: false,
    }),
    viewBox: '0 0 33 34',
  },
  [ICONS.CHECKMARK]: {
    component: dynamic(() => import('@/assets/icons/checkmark.svg') as any, { ssr: false }),
    viewBox: '0 0 24 24',
  },
  [ICONS.CHEVRON_LEFT_WHITE]: {
    component: dynamic(() => import('@/assets/icons/chevron-left-white.svg') as any, {
      ssr: false,
    }),
    viewBox: '0 0 24 24',
  },
  [ICONS.CIRCLE]: {
    component: dynamic(() => import('@/assets/icons/circle.svg') as any, { ssr: false }),
    viewBox: '0 0 100 100',
  },
  [ICONS.CLASS_A]: { sprite: 'vehicleTypes', viewBox: '0 0 36 36' },
  [ICONS.CLASS_B]: { sprite: 'vehicleTypes', viewBox: '0 0 36 36' },
  [ICONS.CLASS_C]: { sprite: 'vehicleTypes', viewBox: '0 0 36 36' },
  [ICONS.CLIPBOARD]: {
    component: dynamic(() => import('@/assets/icons/clipboard.svg') as any, { ssr: false }),
    viewBox: '0 0 24 24',
  },
  [ICONS.CLOCK]: {
    component: dynamic(() => import('@/assets/icons/clock.svg') as any, { ssr: false }),
    viewBox: '0 0 24 24',
  },
  [ICONS.CLOSE]: {
    component: dynamic(() => import('@/assets/icons/close.svg') as any, { ssr: false }),
    viewBox: '0 0 20 20',
  },
  [ICONS.COMPASS]: {
    component: dynamic(() => import('@/assets/icons/compass.svg') as any, { ssr: false }),
    viewBox: '0 0 24 24',
  },
  [ICONS.COPY]: {
    component: dynamic(() => import('@/assets/icons/copy.svg') as any, { ssr: false }),
    viewBox: '0 0 24 24',
  },
  [ICONS.COSTUMER_SERVICE]: {
    component: dynamic(() => import('@/assets/icons/costumer-service.svg') as any, { ssr: false }),
    viewBox: '0 0 24 24',
  },
  [ICONS.COUNTER]: {
    component: dynamic(() => import('@/assets/icons/counter.svg') as any, { ssr: false }),
    viewBox: '0 0 24 24',
  },
  [ICONS.CREDIT_CARD]: {
    component: dynamic(() => import('@/assets/icons/credit-card.svg') as any, { ssr: false }),
    viewBox: '0 0 24 24',
  },
  [ICONS.CURRENCY_CIRCLE_SIGN]: {
    component: dynamic(() => import('@/assets/icons/currency-circle-sign.svg') as any, {
      ssr: false,
    }),
    viewBox: '0 0 48 48',
  },
  [ICONS.CURRENCY_SIGN]: {
    component: dynamic(() => import('@/assets/icons/currency-sign.svg') as any, { ssr: false }),
    viewBox: '0 0 24 24',
  },
  [ICONS.CURRENCY_SIGN_EU]: {
    component: dynamic(() => import('@/assets/icons/currency-sign-eu.svg') as any, { ssr: false }),
    viewBox: '0 0 24 24',
  },
  [ICONS.CURRENCY_SIGN_GBP]: {
    component: dynamic(() => import('@/assets/icons/currency-sign-gbp.svg') as any, { ssr: false }),
    viewBox: '0 0 24 24',
  },
  [ICONS.DASHBOARD]: {
    component: dynamic(() => import('@/assets/icons/dashboard.svg') as any, { ssr: false }),
    viewBox: '0 0 24 24',
  },
  [ICONS.DELIVERY_VAN]: {
    component: dynamic(() => import('@/assets/icons/delivery.svg') as any, { ssr: false }),
    viewBox: '0 0 21 14',
  },
  [ICONS.DEFAULT_CARD]: { sprite: 'cards', viewBox: '0 0 24 24' },
  [ICONS.DINERS]: { sprite: 'cards', viewBox: '0 0 24 24' },
  [ICONS.DISCOVER]: { sprite: 'cards', viewBox: '0 0 24 24' },
  [ICONS.DOWNLOAD]: {
    component: dynamic(() => import('@/assets/icons/download.svg') as any, { ssr: false }),
    viewBox: '0 0 24 24',
  },
  [ICONS.EDIT]: {
    component: dynamic(() => import('@/assets/icons/edit.svg') as any, { ssr: false }),
    viewBox: '0 0 24 24',
  },
  [ICONS.EDIT_DOCUMENT]: {
    component: dynamic(() => import('@/assets/icons/edit-document.svg') as any, { ssr: false }),
    viewBox: '0 0 24 24',
  },
  [ICONS.EDIT_INLINE]: {
    component: dynamic(() => import('@/assets/icons/edit-inline.svg') as any, { ssr: false }),
    viewBox: '0 0 24 24',
  },
  [ICONS.ENHANCED_CLEAN]: {
    component: dynamic(() => import('@/assets/icons/enhanced-clean.svg') as any, { ssr: false }),
    viewBox: '0 0 24 24',
  },
  [ICONS.EXTERNAL_LINK]: {
    component: dynamic(() => import('@/assets/icons/external-link.svg') as any, { ssr: false }),
    viewBox: '0 0 24 24',
  },
  [ICONS.EXTRA_STORAGE]: { sprite: 'amenities', viewBox: '0 0 24 24' },
  [ICONS.EXTRA_STORAGE_UNAVAILABLE]: { sprite: 'amenities', viewBox: '0 0 24 25' },
  [ICONS.EYE]: {
    component: dynamic(() => import('@/assets/icons/eye.svg') as any, { ssr: false }),
    viewBox: '0 0 24 24',
  },
  [ICONS.EYE_OFF]: {
    component: dynamic(() => import('@/assets/icons/eye-off.svg') as any, { ssr: false }),
    viewBox: '0 0 24 24',
  },
  [ICONS.FACEBOOK]: {
    component: dynamic(() => import('@/assets/icons/facebook.svg') as any, { ssr: false }),
    viewBox: '0 0 20 20',
  },
  [ICONS.FACEBOOK_COLORED]: {
    component: dynamic(() => import('@/assets/icons/facebook-colored.svg') as any, { ssr: false }),
    viewBox: '0 0 24 24',
  },
  [ICONS.FACEBOOK_MARK]: {
    component: dynamic(() => import('@/assets/icons/facebook-mark.svg') as any, { ssr: false }),
    viewBox: '0 0 24 24',
  },
  [ICONS.FIFTH_WHEEL]: { sprite: 'vehicleTypes', viewBox: '0 0 36 36' },
  [ICONS.FILE]: {
    component: dynamic(() => import('@/assets/icons/file.svg') as any, { ssr: false }),
    viewBox: '0 0 24 24',
  },
  [ICONS.FILE_TEXT]: {
    component: dynamic(() => import('@/assets/icons/file-text.svg') as any, { ssr: false }),
    viewBox: '0 0 24 24',
  },
  [ICONS.FILTER]: {
    component: dynamic(() => import('@/assets/icons/filter.svg') as any, { ssr: false }),
    viewBox: '0 0 24 24',
  },
  [ICONS.FLAG]: {
    component: dynamic(() => import('@/assets/icons/flag.svg') as any, { ssr: false }),
    viewBox: '0 0 24 24',
  },
  [ICONS.FOLDING_TRAILER]: { sprite: 'vehicleTypes', viewBox: '0 0 36 36' },
  [ICONS.FRESH_WATER]: {
    component: dynamic(() => import('@/assets/icons/fresh-water.svg') as any, { ssr: false }),
    viewBox: '0 0 24 24',
  },
  [ICONS.FRIDGE]: { sprite: 'amenities', viewBox: '0 0 24 24' },
  [ICONS.FRIDGE_UNAVAILABLE]: { sprite: 'amenities', viewBox: '0 0 24 25' },
  [ICONS.FUEL]: {
    component: dynamic(() => import('@/assets/icons/fuel.svg') as any, { ssr: false }),
    viewBox: '0 0 24 24',
  },
  [ICONS.FUEL_TANK]: {
    component: dynamic(() => import('@/assets/icons/fuel-tank.svg') as any, { ssr: false }),
    viewBox: '0 0 24 24',
  },
  [ICONS.GENERATOR]: { sprite: 'amenities', viewBox: '0 0 24 24' },
  [ICONS.GENERATOR_UNAVAILABLE]: { sprite: 'amenities', viewBox: '0 0 24 24' },
  [ICONS.GLOBE]: {
    component: dynamic(() => import('@/assets/icons/globe.svg') as any, { ssr: false }),
    viewBox: '0 0 24 24',
  },
  [ICONS.GOOGLE_COLORED]: {
    component: dynamic(() => import('@/assets/icons/google-colored.svg') as any, { ssr: false }),
    viewBox: '0 0 24 24',
  },
  [ICONS.GREEN_CHECK]: {
    component: dynamic(() => import('@/assets/icons/green-check.svg') as any, { ssr: false }),
    viewBox: '0 0 22 22',
  },
  [ICONS.BLUE_CHECK]: {
    component: dynamic(() => import('@/assets/icons/blue-check.svg') as any, { ssr: false }),
    viewBox: '0 0 22 22',
  },
  [ICONS.GRID]: {
    component: dynamic(() => import('@/assets/icons/grid.svg') as any, { ssr: false }),
    viewBox: '0 0 24 24',
  },
  [ICONS.GROSS_WEIGHT]: {
    component: dynamic(() => import('@/assets/icons/gross-weight.svg') as any, { ssr: false }),
    viewBox: '0 0 24 24',
  },
  [ICONS.HEADPHONES]: {
    component: dynamic(() => import('@/assets/icons/headphones.svg') as any, { ssr: false }),
    viewBox: '0 0 24 24',
  },
  [ICONS.HEART]: {
    component: dynamic(() => import('@/assets/icons/heart.svg') as any, { ssr: false }),
    viewBox: '0 0 12 10',
  },
  [ICONS.HEART_FILLED]: {
    component: dynamic(() => import('@/assets/icons/heart-filled.svg') as any, { ssr: false }),
    viewBox: '0 0 12 10',
  },
  [ICONS.HEATER]: { sprite: 'amenities', viewBox: '0 0 24 24' },
  [ICONS.HEATER_UNAVAILABLE]: { sprite: 'amenities', viewBox: '0 0 24 24' },
  [ICONS.HELP]: {
    component: dynamic(() => import('@/assets/icons/help.svg') as any, { ssr: false }),
    viewBox: '0 0 16 16',
  },
  [ICONS.HOME]: {
    component: dynamic(() => import('@/assets/icons/home.svg') as any, { ssr: false }),
    viewBox: '0 0 24 24',
  },
  [ICONS.IMAGE]: {
    component: dynamic(() => import('@/assets/icons/image.svg') as any, { ssr: false }),
    viewBox: '0 0 24 24',
  },
  [ICONS.INBOX]: {
    component: dynamic(() => import('@/assets/icons/inbox.svg') as any, { ssr: false }),
    viewBox: '0 0 24 24',
  },
  [ICONS.INSTAGRAM_MARK]: {
    component: dynamic(() => import('@/assets/icons/instagram-mark.svg') as any, { ssr: false }),
    viewBox: '0 0 24 24',
  },
  [ICONS.INVERTER]: { sprite: 'amenities', viewBox: '0 0 24 24' },
  [ICONS.INVERTER_UNAVAILABLE]: { sprite: 'amenities', viewBox: '0 0 25 24' },
  [ICONS.JCB]: { sprite: 'cards', viewBox: '0 0 24 24' },
  [ICONS.KITCHEN_SINK]: { sprite: 'amenities', viewBox: '0 0 24 24' },
  [ICONS.KITCHEN_SINK_UNAVAILABLE]: { sprite: 'amenities', viewBox: '0 0 25 25' },
  [ICONS.LENGTH]: {
    component: dynamic(() => import('@/assets/icons/length.svg') as any, { ssr: false }),
    viewBox: '0 0 24 24',
  },
  [ICONS.LEVELING_JACK]: { sprite: 'amenities', viewBox: '0 0 24 24' },
  [ICONS.LEVELING_JACK_UNAVAILABLE]: { sprite: 'amenities', viewBox: '0 0 25 24' },
  [ICONS.LINK]: {
    component: dynamic(() => import('@/assets/icons/link.svg') as any, { ssr: false }),
    viewBox: '0 0 24 24',
  },
  [ICONS.LIST]: {
    component: dynamic(() => import('@/assets/icons/list.svg') as any, { ssr: false }),
    viewBox: '0 0 24 24',
  },
  [ICONS.LOADING]: {
    component: dynamic(() => import('@/assets/icons/loading.svg') as any, { ssr: false }),
    viewBox: '0 0 20 20',
  },
  [ICONS.LOCK]: {
    component: dynamic(() => import('@/assets/icons/lock.svg') as any, { ssr: false }),
    viewBox: '0 0 24 24',
  },
  [ICONS.LOG_IN]: {
    component: dynamic(() => import('@/assets/icons/log-in.svg') as any, { ssr: false }),
    viewBox: '0 0 24 24',
  },
  [ICONS.LOG_OUT]: {
    component: dynamic(() => import('@/assets/icons/log-out.svg') as any, { ssr: false }),
    viewBox: '0 0 24 24',
  },
  [ICONS.MAIL]: {
    component: dynamic(() => import('@/assets/icons/mail.svg') as any, { ssr: false }),
    viewBox: '0 0 24 24',
  },
  [ICONS.MANAGE_VEHICLES]: {
    component: dynamic(() => import('@/assets/icons/manage-vehicles.svg') as any, { ssr: false }),
    viewBox: '0 0 24 24',
  },
  [ICONS.MAP]: {
    component: dynamic(() => import('@/assets/icons/map.svg') as any, { ssr: false }),
    viewBox: '0 0 24 24',
  },
  [ICONS.MAP_PIN]: {
    component: dynamic(() => import('@/assets/icons/map-pin.svg') as any, { ssr: false }),
    viewBox: '0 0 24 24',
  },
  [ICONS.MASTERCARD]: { sprite: 'cards', viewBox: '0 0 24 24' },
  [ICONS.MAXIMIZE]: {
    component: dynamic(() => import('@/assets/icons/maximize.svg') as any, { ssr: false }),
    viewBox: '0 0 24 24',
  },
  [ICONS.MENU]: {
    component: dynamic(() => import('@/assets/icons/menu.svg') as any, { ssr: false }),
    viewBox: '0 0 24 24',
  },
  [ICONS.MESSAGE_CIRCLE]: {
    component: dynamic(() => import('@/assets/icons/message-circle.svg') as any, { ssr: false }),
    viewBox: '0 0 24 24',
  },
  [ICONS.MESSAGE_SQUARE]: {
    component: dynamic(() => import('@/assets/icons/message-square.svg') as any, { ssr: false }),
    viewBox: '0 0 24 24',
  },
  [ICONS.MICROWAVE]: { sprite: 'amenities', viewBox: '0 0 24 24' },
  [ICONS.MICROWAVE_UNAVAILABLE]: { sprite: 'amenities', viewBox: '0 0 25 24' },
  [ICONS.MILEAGE]: {
    component: dynamic(() => import('@/assets/icons/mileage.svg') as any, { ssr: false }),
    viewBox: '0 0 24 24',
  },
  [ICONS.MINIMIZE]: {
    component: dynamic(() => import('@/assets/icons/minimize.svg') as any, { ssr: false }),
    viewBox: '0 0 24 24',
  },
  [ICONS.MINUS]: {
    component: dynamic(() => import('@/assets/icons/minus.svg') as any, { ssr: false }),
    viewBox: '0 0 26 27',
  },
  [ICONS.MINUS_CIRCLE]: {
    component: dynamic(() => import('@/assets/icons/minus-circle.svg') as any, { ssr: false }),
    viewBox: '0 0 24 24',
  },
  [ICONS.MINUS_CIRCLE_BIG]: {
    component: dynamic(() => import('@/assets/icons/minus-circle-big.svg') as any, { ssr: false }),
    viewBox: '0 0 38 38',
  },
  [ICONS.MINUS_SQUARE]: {
    component: dynamic(() => import('@/assets/icons/minus-square.svg') as any, { ssr: false }),
    viewBox: '0 0 24 24',
  },
  [ICONS.MONEY]: {
    component: dynamic(() => import('@/assets/icons/money.svg') as any, { ssr: false }),
    viewBox: '0 0 24 24',
  },
  [ICONS.MONITOR]: {
    component: dynamic(() => import('@/assets/icons/monitor.svg') as any, { ssr: false }),
    viewBox: '0 0 24 24',
  },
  [ICONS.MOON]: {
    component: dynamic(() => import('@/assets/icons/moon.svg') as any, { ssr: false }),
    viewBox: '0 0 24 24',
  },
  [ICONS.MORE_VERTICAL]: {
    component: dynamic(() => import('@/assets/icons/more-vertical.svg') as any, { ssr: false }),
    viewBox: '0 0 24 24',
  },
  [ICONS.MOVE]: {
    component: dynamic(() => import('@/assets/icons/move.svg') as any, { ssr: false }),
    viewBox: '0 0 24 24',
  },
  [ICONS.MUSIC]: {
    component: dynamic(() => import('@/assets/icons/music.svg') as any, { ssr: false }),
    viewBox: '0 0 24 24',
  },
  [ICONS.MUSIC_FESTIVAL]: {
    component: dynamic(() => import('@/assets/icons/music-festival.svg') as any, { ssr: false }),
    viewBox: '0 0 24 24',
  },
  [ICONS.MUSIC_FESTIVAL_NOT_ALLOWED]: {
    component: dynamic(() => import('@/assets/icons/music-festival-not-allowed.svg') as any, {
      ssr: false,
    }),
    viewBox: '0 0 25 24',
  },
  [ICONS.NAVIGATION]: {
    component: dynamic(() => import('@/assets/icons/navigation.svg') as any, { ssr: false }),
    viewBox: '0 0 24 24',
  },
  [ICONS.OLD_TV]: {
    component: dynamic(() => import('@/assets/icons/old-tv.svg') as any, { ssr: false }),
    viewBox: '0 0 24 24',
  },
  [ICONS.OTHER]: { sprite: 'vehicleTypes', viewBox: '0 0 36 36' },
  [ICONS.OUTDOORSY]: {
    component: dynamic(() => import('@/assets/icons/outdoorsy.svg') as any, { ssr: false }),
    viewBox: '0 0 65 15',
  },
  [ICONS.OVEN]: { sprite: 'amenities', viewBox: '0 0 24 24' },
  [ICONS.OVEN_UNAVAILABLE]: { sprite: 'amenities', viewBox: '0 0 32 31' },
  [ICONS.PAUSE]: {
    component: dynamic(() => import('@/assets/icons/pause.svg') as any, { ssr: false }),
    viewBox: '0 0 23 20',
  },
  [ICONS.PEOPLE]: {
    component: dynamic(() => import('@/assets/icons/people.svg') as any, { ssr: false }),
    viewBox: '0 0 30 22',
  },
  [ICONS.PERCENT]: {
    component: dynamic(() => import('@/assets/icons/percent.svg') as any, { ssr: false }),
    viewBox: '0 0 24 24',
  },
  [ICONS.PET_FRIENDLY]: {
    component: dynamic(() => import('@/assets/icons/pet-friendly.svg') as any, { ssr: false }),
    viewBox: '0 0 24 24',
  },
  [ICONS.PET_NOT_ALLOWED]: {
    component: dynamic(() => import('@/assets/icons/pet-not-allowed.svg') as any, { ssr: false }),
    viewBox: '0 0 24 24',
  },
  [ICONS.PHONE]: {
    component: dynamic(() => import('@/assets/icons/phone.svg') as any, { ssr: false }),
    viewBox: '0 0 24 24',
  },
  [ICONS.PHONE_CALL]: {
    component: dynamic(() => import('@/assets/icons/phone-call.svg') as any, { ssr: false }),
    viewBox: '0 0 24 24',
  },
  [ICONS.PHONE_INCOMING]: {
    component: dynamic(() => import('@/assets/icons/phone-incoming.svg') as any, { ssr: false }),
    viewBox: '0 0 24 24',
  },
  [ICONS.PHONE_OFF]: {
    component: dynamic(() => import('@/assets/icons/phone-off.svg') as any, { ssr: false }),
    viewBox: '0 0 24 24',
  },
  [ICONS.PHONE_OUTGOING]: {
    component: dynamic(() => import('@/assets/icons/phone-outgoing.svg') as any, { ssr: false }),
    viewBox: '0 0 24 24',
  },
  [ICONS.PIE_CHART]: {
    component: dynamic(() => import('@/assets/icons/pie-chart.svg') as any, { ssr: false }),
    viewBox: '0 0 24 24',
  },
  [ICONS.PINTEREST]: {
    component: dynamic(() => import('@/assets/icons/pinterest.svg') as any, { ssr: false }),
    viewBox: '0 0 24 24',
  },
  [ICONS.PLAY]: {
    component: dynamic(() => import('@/assets/icons/play.svg') as any, { ssr: false }),
    viewBox: '0 0 20 20',
  },
  [ICONS.PLUS]: {
    component: dynamic(() => import('@/assets/icons/plus.svg') as any, { ssr: false }),
    viewBox: '0 0 24 24',
  },
  [ICONS.PLUS_CIRCLE]: {
    component: dynamic(() => import('@/assets/icons/plus-circle.svg') as any, { ssr: false }),
    viewBox: '0 0 24 24',
  },
  [ICONS.PLUS_CIRCLE_BIG]: {
    component: dynamic(() => import('@/assets/icons/plus-circle-big.svg') as any, { ssr: false }),
    viewBox: '0 0 38 38',
  },
  [ICONS.PLUS_SQUARE]: {
    component: dynamic(() => import('@/assets/icons/plus-square.svg') as any, { ssr: false }),
    viewBox: '0 0 24 24',
  },
  [ICONS.PRINTER]: {
    component: dynamic(() => import('@/assets/icons/printer.svg') as any, { ssr: false }),
    viewBox: '0 0 24 24',
  },
  [ICONS.PROPANE_TANK]: {
    component: dynamic(() => import('@/assets/icons/propane-tank.svg') as any, { ssr: false }),
    viewBox: '0 0 24 24',
  },
  [ICONS.RADIO]: { sprite: 'amenities', viewBox: '0 0 24 24' },
  [ICONS.RADIO_UNAVAILABLE]: { sprite: 'amenities', viewBox: '0 0 25 24' },
  [ICONS.REFRESH_CCW]: {
    component: dynamic(() => import('@/assets/icons/refresh-ccw.svg') as any, { ssr: false }),
    viewBox: '0 0 24 24',
  },
  [ICONS.REFRESH_CW]: {
    component: dynamic(() => import('@/assets/icons/refresh-cw.svg') as any, { ssr: false }),
    viewBox: '0 0 24 24',
  },
  [ICONS.REPEAT]: {
    component: dynamic(() => import('@/assets/icons/repeat.svg') as any, { ssr: false }),
    viewBox: '0 0 24 24',
  },
  [ICONS.REPORT]: {
    component: dynamic(() => import('@/assets/icons/report.svg') as any, { ssr: false }),
    viewBox: '0 0 20 20',
  },
  [ICONS.ROTATE_CCW]: {
    component: dynamic(() => import('@/assets/icons/rotate-ccw.svg') as any, { ssr: false }),
    viewBox: '0 0 24 24',
  },
  [ICONS.ROTATE_CW]: {
    component: dynamic(() => import('@/assets/icons/rotate-cw.svg') as any, { ssr: false }),
    viewBox: '0 0 24 24',
  },
  [ICONS.SATELLITE]: { sprite: 'amenities', viewBox: '0 0 24 24' },
  [ICONS.SATELLITE_UNAVAILABLE]: { sprite: 'amenities', viewBox: '0 0 25 25' },
  [ICONS.SAVE]: {
    component: dynamic(() => import('@/assets/icons/save.svg') as any, { ssr: false }),
    viewBox: '0 0 24 24',
  },
  [ICONS.SCISSORS]: {
    component: dynamic(() => import('@/assets/icons/scissors.svg') as any, { ssr: false }),
    viewBox: '0 0 24 24',
  },
  [ICONS.SEARCH]: {
    component: dynamic(() => import('@/assets/icons/search.svg') as any, { ssr: false }),
    viewBox: '0 0 24 24',
  },
  [ICONS.SEATBELTS]: {
    component: dynamic(() => import('@/assets/icons/seatbelts.svg') as any, { ssr: false }),
    viewBox: '0 0 24 24',
  },
  [ICONS.SETTINGS]: {
    component: dynamic(() => import('@/assets/icons/settings.svg') as any, { ssr: false }),
    viewBox: '0 0 24 24',
  },
  [ICONS.SEWAGE_TANK]: {
    component: dynamic(() => import('@/assets/icons/sewage-tank.svg') as any, { ssr: false }),
    viewBox: '0 0 24 24',
  },
  [ICONS.SHARE]: {
    component: dynamic(() => import('@/assets/icons/share.svg') as any, { ssr: false }),
    viewBox: '0 0 20 20',
  },
  [ICONS.SHIELD]: {
    component: dynamic(() => import('@/assets/icons/shield.svg') as any, { ssr: false }),
    viewBox: '0 0 24 24',
  },
  [ICONS.SHIELD_CHECK]: {
    component: dynamic(() => import('@/assets/icons/shield-check.svg') as any, { ssr: false }),
    viewBox: '0 0 17 20',
  },
  [ICONS.SHIELD_OFF]: {
    component: dynamic(() => import('@/assets/icons/shield-off.svg') as any, { ssr: false }),
    viewBox: '0 0 24 24',
  },
  [ICONS.SHIELD_PLUS]: {
    component: dynamic(() => import('@/assets/icons/shield-plus.svg') as any, { ssr: false }),
    viewBox: '0 0 24 24',
  },
  [ICONS.SHOPPING_BAG]: {
    component: dynamic(() => import('@/assets/icons/shopping-bag.svg') as any, { ssr: false }),
    viewBox: '0 0 24 24',
  },
  [ICONS.SHOPPING_CART]: {
    component: dynamic(() => import('@/assets/icons/shopping-cart.svg') as any, { ssr: false }),
    viewBox: '0 0 24 24',
  },
  [ICONS.SHOWER_INSIDE]: { sprite: 'amenities', viewBox: '0 0 24 24' },
  [ICONS.SHOWER_INSIDE_UNAVAILABLE]: { sprite: 'amenities', viewBox: '0 0 24 25' },
  [ICONS.SHOWER_OUTSIDE]: { sprite: 'amenities', viewBox: '0 0 24 24' },
  [ICONS.SHOWER_OUTSIDE_UNAVAILABLE]: { sprite: 'amenities', viewBox: '0 0 25 25' },
  [ICONS.SHUFFLE]: {
    component: dynamic(() => import('@/assets/icons/shuffle.svg') as any, { ssr: false }),
    viewBox: '0 0 24 24',
  },
  [ICONS.SLEEPS]: {
    component: dynamic(() => import('@/assets/icons/sleeps.svg') as any, { ssr: false }),
    viewBox: '0 0 24 24',
  },
  [ICONS.SLIDERS]: {
    component: dynamic(() => import('@/assets/icons/sliders.svg') as any, { ssr: false }),
    viewBox: '0 0 22 24',
  },
  [ICONS.SMARTPHONE]: {
    component: dynamic(() => import('@/assets/icons/smartphone.svg') as any, { ssr: false }),
    viewBox: '0 0 24 24',
  },
  [ICONS.SMOKING]: {
    component: dynamic(() => import('@/assets/icons/smoking.svg') as any, { ssr: false }),
    viewBox: '0 0 24 24',
  },
  [ICONS.SMOKING_NOT_ALLOWED]: {
    component: dynamic(() => import('@/assets/icons/smoking-not-allowed.svg') as any, {
      ssr: false,
    }),
    viewBox: '0 0 25 24',
  },
  [ICONS.SOLAR]: { sprite: 'amenities', viewBox: '0 0 24 24' },
  [ICONS.SOLAR_UNAVAILABLE]: { sprite: 'amenities', viewBox: '0 0 24 24' },
  [ICONS.STAR]: {
    component: dynamic(() => import('@/assets/icons/star.svg') as any, { ssr: false }),
    viewBox: '0 0 12 11',
  },
  [ICONS.STAR_OUTLINE]: {
    component: dynamic(() => import('@/assets/icons/star-outline.svg') as any, { ssr: false }),
    viewBox: '0 0 20 20',
  },
  [ICONS.STATIONARY]: {
    component: dynamic(() => import('@/assets/icons/stationary.svg') as any, { ssr: false }),
    viewBox: '0 0 28 28',
  },
  [ICONS.STOVE]: { sprite: 'amenities', viewBox: '0 0 24 24' },
  [ICONS.STOVE_UNAVAILABLE]: { sprite: 'amenities', viewBox: '0 0 24 24' },
  [ICONS.SUN]: {
    component: dynamic(() => import('@/assets/icons/sun.svg') as any, { ssr: false }),
    viewBox: '0 0 24 24',
  },
  [ICONS.SUNRISE]: {
    component: dynamic(() => import('@/assets/icons/sunrise.svg') as any, { ssr: false }),
    viewBox: '0 0 24 24',
  },
  [ICONS.SUNSET]: {
    component: dynamic(() => import('@/assets/icons/sunset.svg') as any, { ssr: false }),
    viewBox: '0 0 24 24',
  },
  [ICONS.TABLE]: { sprite: 'amenities', viewBox: '0 0 24 24' },
  [ICONS.TABLE_UNAVAILABLE]: { sprite: 'amenities', viewBox: '0 0 24 24' },
  [ICONS.TABLET]: {
    component: dynamic(() => import('@/assets/icons/tablet.svg') as any, { ssr: false }),
    viewBox: '0 0 24 24',
  },
  [ICONS.TAG]: {
    component: dynamic(() => import('@/assets/icons/tag.svg') as any, { ssr: false }),
    viewBox: '0 0 24 24',
  },
  [ICONS.TAILGATING]: {
    component: dynamic(() => import('@/assets/icons/tailgating.svg') as any, { ssr: false }),
    viewBox: '0 0 24 24',
  },
  [ICONS.TAILGATING_NOT_ALLOWED]: {
    component: dynamic(() => import('@/assets/icons/tailgating-not-allowed.svg') as any, {
      ssr: false,
    }),
    viewBox: '0 0 25 24',
  },
  [ICONS.THUMBS_DOWN]: {
    component: dynamic(() => import('@/assets/icons/thumbs-down.svg') as any, { ssr: false }),
    viewBox: '0 0 24 24',
  },
  [ICONS.THUMBS_UP]: {
    component: dynamic(() => import('@/assets/icons/thumbs-up.svg') as any, { ssr: false }),
    viewBox: '0 0 24 24',
  },
  [ICONS.TOILET]: { sprite: 'amenities', viewBox: '0 0 24 24' },
  [ICONS.TOILET_UNAVAILABLE]: { sprite: 'amenities', viewBox: '0 0 24 24' },
  [ICONS.TOW_HITCH]: { sprite: 'amenities', viewBox: '0 0 24 24' },
  [ICONS.TOW_HITCH_UNAVAILABLE]: { sprite: 'amenities', viewBox: '0 0 25 24' },
  [ICONS.TOY_HAULER]: { sprite: 'vehicleTypes', viewBox: '0 0 36 36' },
  [ICONS.TRAILER]: { sprite: 'vehicleTypes', viewBox: '0 0 36 36' },
  [ICONS.TRANSMISSION]: {
    component: dynamic(() => import('@/assets/icons/transmission.svg') as any, { ssr: false }),
    viewBox: '0 0 24 24',
  },
  [ICONS.TRENDING_DOWN]: {
    component: dynamic(() => import('@/assets/icons/trending-down.svg') as any, { ssr: false }),
    viewBox: '0 0 24 24',
  },
  [ICONS.TRENDING_UP]: {
    component: dynamic(() => import('@/assets/icons/trending-up.svg') as any, { ssr: false }),
    viewBox: '0 0 24 24',
  },
  [ICONS.TRIPS]: {
    component: dynamic(() => import('@/assets/icons/trips.svg') as any, { ssr: false }),
    viewBox: '0 0 24 24',
  },
  [ICONS.TRUCK]: {
    component: dynamic(() => import('@/assets/icons/truck.svg') as any, { ssr: false }),
    viewBox: '0 0 24 24',
  },
  [ICONS.TRUCK_CAMPER]: { sprite: 'vehicleTypes', viewBox: '0 0 36 36' },
  [ICONS.TV]: { sprite: 'amenities', viewBox: '0 0 24 24' },
  [ICONS.TV_UNAVAILABLE]: { sprite: 'amenities', viewBox: '0 0 25 24' },
  [ICONS.TWITTER]: {
    component: dynamic(() => import('@/assets/icons/twitter.svg') as any, { ssr: false }),
    viewBox: '0 0 20 17',
  },
  [ICONS.TWITTER_MARK]: {
    component: dynamic(() => import('@/assets/icons/twitter-mark.svg') as any, { ssr: false }),
    viewBox: '0 0 24 24',
  },
  [ICONS.UMBRELLA]: {
    component: dynamic(() => import('@/assets/icons/umbrella.svg') as any, { ssr: false }),
    viewBox: '0 0 24 24',
  },
  [ICONS.UNIONPAY]: { sprite: 'cards', viewBox: '0 0 24 24' },
  [ICONS.UNLOCK]: {
    component: dynamic(() => import('@/assets/icons/unlock.svg') as any, { ssr: false }),
    viewBox: '0 0 24 24',
  },
  [ICONS.UPLOAD]: {
    component: dynamic(() => import('@/assets/icons/upload.svg') as any, { ssr: false }),
    viewBox: '0 0 24 24',
  },
  [ICONS.UPLOAD_CLOUD]: {
    component: dynamic(() => import('@/assets/icons/upload-cloud.svg') as any, { ssr: false }),
    viewBox: '0 0 24 24',
  },
  [ICONS.USER]: {
    component: dynamic(() => import('@/assets/icons/user.svg') as any, { ssr: false }),
    viewBox: '0 0 24 24',
  },
  [ICONS.USER_CHECK]: {
    component: dynamic(() => import('@/assets/icons/user-check.svg') as any, { ssr: false }),
    viewBox: '0 0 24 24',
  },
  [ICONS.USER_PLUS]: {
    component: dynamic(() => import('@/assets/icons/user-plus.svg') as any, { ssr: false }),
    viewBox: '0 0 24 24',
  },
  [ICONS.USERS]: {
    component: dynamic(() => import('@/assets/icons/users.svg') as any, { ssr: false }),
    viewBox: '0 0 24 24',
  },
  [ICONS.UTILITY_TRAILER]: { sprite: 'vehicleTypes', viewBox: '0 0 36 36' },
  [ICONS.VIDEO]: {
    component: dynamic(() => import('@/assets/icons/video.svg') as any, { ssr: false }),
    viewBox: '0 0 24 24',
  },
  [ICONS.VIDEO_OFF]: {
    component: dynamic(() => import('@/assets/icons/video-off.svg') as any, { ssr: false }),
    viewBox: '0 0 24 24',
  },
  [ICONS.VISA]: { sprite: 'cards', viewBox: '0 0 24 24' },
  [ICONS.VOLUME]: {
    component: dynamic(() => import('@/assets/icons/volume.svg') as any, { ssr: false }),
    viewBox: '0 0 20 20',
  },
  [ICONS.WASHER_DRYER]: { sprite: 'amenities', viewBox: '0 0 24 24' },
  [ICONS.WASHER_DRYER_UNAVAILABLE]: { sprite: 'amenities', viewBox: '0 0 25 24' },
  [ICONS.WATER_TANK]: {
    component: dynamic(() => import('@/assets/icons/water-tank.svg') as any, { ssr: false }),
    viewBox: '0 0 24 24',
  },
  [ICONS.WIFI]: { sprite: 'amenities', viewBox: '0 0 24 24' },
  [ICONS.WIFI_OFF]: {
    component: dynamic(() => import('@/assets/icons/wifi-off.svg') as any, { ssr: false }),
    viewBox: '0 0 24 24',
  },
  [ICONS.WIFI_UNAVAILABLE]: { sprite: 'amenities', viewBox: '0 0 25 24' },
  [ICONS.X_CIRCLE]: {
    component: dynamic(() => import('@/assets/icons/x-circle.svg') as any, { ssr: false }),
    viewBox: '0 0 24 24',
  },
  [ICONS.X_SQUARE]: {
    component: dynamic(() => import('@/assets/icons/x-square.svg') as any, { ssr: false }),
    viewBox: '0 0 24 24',
  },
  [ICONS.YOUTUBE_MARK]: {
    component: dynamic(() => import('@/assets/icons/youtube-mark.svg') as any, { ssr: false }),
    viewBox: '0 0 25 24',
  },
  [ICONS.ZAP]: {
    component: dynamic(() => import('@/assets/icons/zap.svg') as any, { ssr: false }),
    viewBox: '0 0 24 24',
  },
  [ICONS.ZAP_OFF]: {
    component: dynamic(() => import('@/assets/icons/zap-off.svg') as any, { ssr: false }),
    viewBox: '0 0 24 24',
  },
  [ICONS.ADDRESS_MARKER]: {
    component: dynamic(() => import('@/assets/icons/address-marker.svg') as any, { ssr: false }),
    viewBox: '0 0 24 24',
  },
};
